export default "__VITE_ASSET__D8hv440c__"